import React from "react";
import { formatTemperature } from "../../../helpers/formatters/temperature";
import { useLocationSummary } from "../../../network/matlocq/queries/LocationSummary";
import { WeatherIcon } from "../../WeatherIcon";
import styles from "./styles.module.scss";

type Props = {
    code: string;
    removeFavorite: (code: string) => void;
};

export const FavoriteItemDesktop: React.FC<Props> = ({
    code,
    removeFavorite,
}) => {
    const { data: favorite } = useLocationSummary(code);

    if (!favorite?.location?.slug) {
        return null;
    }

    return (
        <div className={styles.item}>
            <a className={styles.link} href={`/${favorite.location.slug}`}>
                <div className={styles.weatherIcon}>
                    <WeatherIcon
                        url={
                            favorite.forecastSummary.items[0]?.weatherAggregated
                                ?.iconUrl ?? null
                        }
                        alt={
                            favorite.forecastSummary.items[0]?.weatherAggregated
                                ?.text ?? ""
                        }
                        title={
                            favorite.forecastSummary.items[0]?.weatherAggregated
                                ?.text ?? ""
                        }
                        imgTagSize={{
                            width: 54,
                            height: 34,
                        }}
                        lazyloadImage={false}
                    />
                </div>
                <div className={styles.name}>
                    {favorite.location?.name ?? ""}
                </div>
                <div className={styles.temperature}>
                    <span className={styles.temperatureMax}>
                        {formatTemperature(
                            favorite.forecastSummary.items[0]?.temperature?.max
                        )}
                    </span>
                    <span className={styles.temperatureMin}>
                        &nbsp;/&nbsp;
                        {formatTemperature(
                            favorite.forecastSummary.items[0]?.temperature?.min
                        )}
                    </span>
                </div>
            </a>
            <button
                className={styles.actions}
                onClick={() => removeFavorite(favorite?.location?.code ?? "")}
            >
                <span className="icon-bin" />
            </button>
        </div>
    );
};
